import { selfAssemblyInputState } from "shared/store/selfAssembly/selfAssemblyInputs";
import { useSnapshot } from "valtio";
import {
  kaderdeurDoorPositions,
  kaderdeurSelectableWidths,
} from "../../../../app/providers/DoorOptionsProvider";
import Label from "../../../../shared/ui/label";
import { WidthSimpleButton } from "./WidthSimpleButton";

type KaderdeurSelfMontageWidthsType = {
  totalDoors: number;
  setWidth: (width: number, index: number) => void;
  selectedWidths: number[];
};

export const KaderdeurSelfMontageWidths = ({
  totalDoors,
  setWidth,
  selectedWidths,
}: KaderdeurSelfMontageWidthsType) => {
  const widthInputFieldSnapshot = useSnapshot(selfAssemblyInputState);

  return (
    <>
      {[...Array(totalDoors)].map((_, i) => (
        <div key={i} className="gg-mb-4">
          {totalDoors > 1 && (
            <Label htmlFor="name" className="gg-mb-2 gg-text-sm gg-font-bold">
              {kaderdeurDoorPositions[i]}
            </Label>
          )}
          <div
            data-testid="width-kaderdeur-buttons"
            className="gg-mt-0.5 gg-grid gg-grid-cols-3 gg-gap-x-5 gg-gap-y-4"
          >
            {kaderdeurSelectableWidths.map((width) => (
              <WidthSimpleButton
                key={width}
                onClick={() => setWidth(width, i)}
                isActive={
                  selectedWidths[i] === width &&
                  !!widthInputFieldSnapshot.widthInput
                }
              >
                {width}
              </WidthSimpleButton>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};
